/*
 * @Descripttion: 
 * @version: 
 * @Author: FuDi
 * @Date: 2021-11-08 15:58:55
 * @LastEditTime: 2023-03-10 10:17:55
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from "../views/layout/Index.vue";
import { routeArray } from '@/utils/routerList'

Vue.use(VueRouter)


const routes = [{
        path: '/',
        redirect: '/layout/Index',
    },
    {
        path: "/layout/Index",
        name: "Index",
        redirect: "/Home",
        component: Index,
        children: routeArray
    },
    {
        path: "/faceIsSuccess",
        name: "faceIsSuccess",
        meta: {
            title: "人脸识别",
        },

        component: () =>
            import ( /* webpackChunkName: "AuthenticationName" */ '../views/userCenter/faceIsSuccess'),
    },
    {
        path: '/enterpriseCation',
        name: 'enterpriseCation',
        meta: {
            title: '企业实名资料完善',
        },
        component: () =>
            import ( /* webpackChunkName: "privacyApp" */ '../views/enterpriseCation/pc'),
    },
    {
        path: "/invoice/download",
        name: "download",
        meta: {
            title: "发票下载",
        },

        component: () =>
            import ( /* webpackChunkName: "download" */ '../views/invoice/download'),
    },

]
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    console.log(targetPath);
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});
export default router